import { AttributeValue } from "../../../library-js/dom-tools/AttributeValue";
import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { ElementSelector } from "../../../library-js/dom-tools/ElementSelector";
import { OnChange, OnClick, OnInput, OnKeyUp } from "../../../library-js/dom-tools/EventListeners";
import { URLHash } from "../../../library-js/dom/URLHash";
import { RegexValidator } from "../../../library-js/validators/RegexValidator";
import { EmailValidator } from "../../../library-js/validators/EmailValidator";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { Rokojori } from "../Rokojori";
import { UserSignUpRequest } from "../../../library-js/php/user/UserSignUpRequest";
import { UserAccountCreationInput, UserCreateAccountRequest } from "../../../library-js/php/user/UserCreateAccountRequest";
import { UserAccountBlock } from "./UserAccountBlock";
import { copySync } from "fs-extra";
import { Overlay } from "../overlay/Overlay";
import { TimePin } from "../../../library-js/animation/TimePin";
import { UserLocales } from "../i8/UserLocales";
import { PageHandler } from "../../../library-js/dom-tools/PageHandler";
import { OverlayHint } from "../overlay/OverlayHint";
import { UserLoginResponse } from "../../../library-js/php/user/UserLoginRequest";
import { Cookies } from "../../../library-js/php/cookie-info/Cookies";

export class LoginUI
{
  static readonly attribute = new ElementAttribute( "login" );
  static readonly selector = new ElementSelector( UserAccountBlock.type, LoginUI.attribute );

  static readonly successHint = new ElementType<HTMLElement>( "success-content" );
  static readonly errorHint   = new ElementType<HTMLElement>( "error-content" );
  static readonly userName   = new ElementType<HTMLElement>( "user-name" );



  static applyOnDocument()
  {
    LoginUI.selector.forAllInDoc( e => LoginUI.applyOnElement( e ) );
  }  

  static applyOnElement( e:HTMLElement )
  {
    ClassFlag.hidden.removeFrom( UserAccountBlock.inputBlock.query( e ) );

    let inputs = ElementType.input.queryAll( e );

    let emailInput = UserAccountBlock.emailInput.find( inputs ) as HTMLInputElement;
    let pwInput    = UserAccountBlock.pwInput.find( inputs ) as HTMLInputElement; 

    let userButton = UserAccountBlock.userButton.query( e ) as HTMLElement; 

    ClassFlag.enabled.set( userButton );
    
    UserAccountBlock.blurOnEnter( emailInput );
    UserAccountBlock.blurOnEnter( pwInput );

    
    
    let anchor = ElementType.anchor.getParent( userButton );
    PageHandler.setFunctionHandleLink( anchor, Rokojori.locale( UserLocales.loginButtonLinkInfo ),
      async ()=>
      { 
        let email = emailInput.value;
        let password = pwInput.value;

        Rokojori.$.showLoaderScreen( UserLocales.loggingInLoaderScreenInfo );

        let pin = TimePin.create();
        
        let user = Rokojori.$.userSystem;
        let debugOutput:string[] = [];
        let couldLogIn = await user.login( email, password, debugOutput );

        console.log( couldLogIn );

        await pin.forMS( 1000 ); 

        pin.now();

        Rokojori.$.hideLoaderScreen();
        
        await pin.forMS( 300 ); 

        if ( ! couldLogIn )
        {
          let errorContent = LoginUI.errorHint.query( e );
          let cloned = errorContent.cloneNode( true ) as HTMLElement;
          let hintOverlay = new ElementType( "hint-overlay" ).query( cloned );
          hintOverlay.appendChild( document.createTextNode( debugOutput.join( "," ) ) );
          Overlay.show( cloned );  
        }
        else
        {          

          // await Cookies.set( Rokojori.phpContext, user.tokenName, response.value.id );
          // await Cookies.set( Rokojori.phpContext, user.tokenRefreshName, response.value.refreshID  );

          // await Rokojori.$.user.checkLoginStatus();

          let successContent = LoginUI.successHint.query( e );
          let cloned = successContent.cloneNode( true ) as HTMLElement;
          let userName = LoginUI.userName.query( cloned );
          HTMLEditor.setText( userName, email );
          Overlay.show( cloned );  
        }
        
        
      }
    );
    
  }


}